module.exports = __webpack_public_path__ + "img/nl-backdrop.17b59995.png";